function initInstance(component) {
    const container = component.querySelector('.tabs-component__container');
    const navContainer = component.querySelector('.tabs-component__nav-container');
    const arrowContainer = component.querySelector('.tabs-component__navigation')

    if (!container || !navContainer || !arrowContainer) return null;

    const NAV_OVERLAP = 30;

    let observedVisual = null;

    // Desktop only: the video is anchored from the top of the panel there, so the CSS
    // offset needs to know how tall the video is. See top on .tabs-component__video.
    // The mobile layout keeps the video in normal flow and ignores this.
    const setMediaHeight = () => {
        const activePanel = container.querySelector('.accordion__item--active');
        const visual = activePanel?.querySelector('.tabs-component__video:not(.mobile)');
        if (!visual || visual.offsetParent === null) return;

        component.style.setProperty('--tabs-media-height', `${Math.round(visual.getBoundingClientRect().height)}px`);
    };

    const update = () => {
        if (getComputedStyle(navContainer).position !== 'absolute') {
            setMediaHeight();
            navContainer.style.top = '';
            return;
        }

        if (getComputedStyle(arrowContainer).position !== 'absolute') {
            arrowContainer.style.top = '';
            return;
        }

        const activePanel = container.querySelector('.accordion__item--active');
        if (!activePanel) return;

        const visual = activePanel.querySelector('.tabs-component__video');
        if (!visual) return;

        const offsetParent = navContainer.offsetParent || container;
        const offsetParentRect = offsetParent.getBoundingClientRect();
        const visualRect = visual.getBoundingClientRect();

        navContainer.style.top = `${(visualRect.bottom - offsetParentRect.top) - NAV_OVERLAP}px`;
        arrowContainer.style.top = `${(visualRect.bottom - offsetParentRect.top) - NAV_OVERLAP}px`;

        if (visual !== observedVisual) {
            if (observedVisual) resizeObserver.unobserve(observedVisual);
            resizeObserver.observe(visual);
            observedVisual = visual;
        }
    };

    const resizeObserver = new ResizeObserver(update);

    const mutationObserver = new MutationObserver(update);
    mutationObserver.observe(container, {
        attributes: true,
        attributeFilter: ['class'],
        subtree: true
    });

    update();

    return update;
}

export function positionToNav() {
    const components = document.querySelectorAll('.tabs-component');
    const updaters = Array.from(components)
        .map(initInstance)
        .filter(Boolean);

    if (!updaters.length) return;

    let resizeTimeout;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => updaters.forEach(fn => fn()), 100);
    });
}